module.exports = __webpack_public_path__ + "static/ball-86b549788c7735e336b65c59697ea01c.webp";